export default {"src":"/_next/static/media/mail.5ddd20a5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};